import React, { useEffect, useState } from "react";
import './Precios.scss'
import TitleView from "../../components/atoms/TitleView/TitleView";
import GlovalCard from "../../components/atoms/GlovalCard/GlovalCard";
import InputCalendario from "../../components/atoms/InputCalendario/InputCalendario";
import InputLista from "../../components/atoms/InputLista/InputLista";
import camionIcon from '../../assets/icons/bus.png'

import { getClients } from "../monitoreo/MonitoreoServicios/MonitoreoServiciosIntegracion";
import { transferisServiciosIntegracion } from "../monitoreo/TransferirServicios/transferisServiciosIntegracion";
import { getPreciosByIdRuta } from "./PreciosIntegracion";
import Button from "../../components/atoms/Button/Button";
import ButtonGris from "../../components/atoms/ButtonGris/ButtonGris";
import { useNavigate } from "react-router-dom";
const Precios = () => {
    const navigate = useNavigate()
    const [clientes,setClientes] = useState([])
    const [cliente,setCliente] = useState(null)
    const [rutas,setRutas] = useState([])
    const [ruta,setRuta] = useState(null)
    const [precios,setPrecios] = useState(null)
    useEffect(()=>{
        getClients(setClientes)
    },[])
    useEffect(()=>{
        if(cliente)
        {
            transferisServiciosIntegracion.getRutesByIdClient(cliente.code,setRutas)
        }
    },[cliente])
    useEffect(()=>{
        if(ruta)
        {
            getPreciosByIdRuta(ruta?.code,setPrecios)

        }
    },[ruta])
    
    return (
        <div className="Precios">
            <TitleView title={"Precios"}></TitleView>
            <GlovalCard className={"contenedor-inputs"}>
                <b>
                    <div className="inputCOntainerROw">
                        <InputLista options={clientes} value={cliente} onChange={(e)=>{setCliente(e.value)}} titulo={"Cliente"}></InputLista>
                        <InputLista options={rutas} value={ruta} onChange={(e)=>{setRuta(e.value)}} titulo={"Ruta"}></InputLista>
                    </div>
                </b>

            </GlovalCard>
            <GlovalCard>
                {
                    precios?.map((item)=>
                    {
                        return(
                            <div className="containerInfo">
                                <div className="element">
                                    <div className="title">Ruta</div>
                                    <div className="turno">
                                        <img src={camionIcon} alt="" />
                                        <div className="text">{item.TURNO}</div>
                                    </div>
                                </div>
                                {/* --------------------------------------------------------------------- */}
                                <div className="element">
                                    <div className="title">Tipo de unidad</div>
                                    <div className="text">{item.TIPO_UNIDAD?item.TIPO_UNIDAD:"No asignado"}</div>
                                </div>
                                {/* --------------------------------------------------------------------- */}
                                <div className="element">
                                    <div className="title">Pago Operador</div>
                                    <div className="text">{item.PAGO_CHOFER}</div>
                                </div>
                                {/* --------------------------------------------------------------------- */}
                                <div className="element">
                                    <div className="title">Pago Aliado</div>
                                    <div className="text">{item.PAGO_SUBCONTRATADO}</div>
                                </div>
                                {/* --------------------------------------------------------------------- */}
                                <div className="element">
                                    <div className="title">Pago Cliente</div>
                                    <div className="text">{item.PRECIO_CLIENTE}</div>
                                </div>
                                {/* --------------------------------------------------------------------- */}
                                
                            </div>
                        )
                    })
                }
            </GlovalCard>
        </div>
    )
}
export default Precios